import { jobFilterPosted, jobFilterPrices } from '../constants/jobs'

const getJobListFilters = (search, filters) => {
  try {
    const timeRange =
      filters.posted !== '_'
        ? jobFilterPosted.find((posted) => posted.value === filters.posted)
        : undefined
    const priceRange =
      filters.price !== '_'
        ? jobFilterPrices.find((price) => price.value === filters.price)
        : undefined

    return {
      ...filters,
      search: search?.trim?.() || undefined,
      price: undefined,
      posted: undefined,
      job_category: filters.job_category === '_' ? undefined : filters.job_category,
      languages: filters.languages === '_' ? undefined : filters.languages,
      price_type: filters.price_type === '_' ? undefined : filters.price_type,
      time_range: timeRange?.value || undefined,
      price__range: priceRange?.value || undefined,
      price__gte:
        typeof priceRange?.value === 'string' && !priceRange.value.includes('_')
          ? priceRange.value
          : undefined,
    }
  } catch (e) {
    console.log(e)
    return filters
  }
}

export default getJobListFilters
